export default "__VITE_ASSET__ecaFL4YN__"